<div *ngIf="data.length > 0">
  <valg-table
  [columnDefinition]="mandatesListColumnDef"
  [data]="data"
  [itemName]="'mandates_list.item_name' | translate"
  [title]="'mandates_list.title' | translate"
  [hasPagination]="false"
  [displayItemCount]="false"
  [hasMainActionButton]="false">
      <h2 class="m-0 text--f20 text--500">{{ 'mandates_list.title' | translate }}</h2>
      <valg-dk-result-summary content-position="pre-table" [resultSummary]="resultSummary" *ngIf="!basedOnMissingResults"></valg-dk-result-summary>
      <div color="error-gray" valg-message-bar *ngIf="basedOnMissingResults">
          <span class="text--500">{{ 'mandates_list.errors.based_on_missing_results.title' | translate }} </span>
          <span>{{ 'mandates_list.errors.based_on_missing_results.message'  | translate }}</span>
      </div>
  </valg-table>
</div>
<div *ngIf="data.length === 0" class="p-5">
  <h2 class="mt-0 text--f20 text--500">{{ 'mandates_list.title' | translate }}</h2>
  {{"mandates_list.no_data_description" | translate}}
</div>
